<template>
  <base-panel :title="messageBoardTitle" :titleIcon="titleIcon" actionLabel="我的留言卡片" @clickMore="handleClickMore" :showAction="showAction">
    <transition-group name="list" tag="ul" class="message-list">
      <li class="message-item" v-for="item in currentMessageList" :key="`message_${item.key}`" :class="item.colorClass">
        <div class="message-wrapper">
          <p class="message">
            <span class="name">{{ `${item.userName}：` }}</span>
            <span class="content">{{ item.message }}</span>
          </p>
        </div>
      </li>
    </transition-group>
  </base-panel>
</template>

<script>
import BasePanel from "../BasePanel"
import nfpluslogin from "@/mixins/nfplusLogin"
import { mapGetters } from "vuex"

const TITLE_ICON = require("../../assets/images/tag.png")

export default {
  name: "uiMessageBoard",
  props: {
    showAction: {
      type: Boolean,
      default: true
    }
  },
  mixins: [nfpluslogin],
  methods: {
    async handleClickMore() {
      const hasUserInfo = await this.nfplusLogin()
      hasUserInfo && this.$emit("clickMore")
    }
  },
  components: {
    BasePanel
  },
  computed: {
    ...mapGetters({
      currentMessageList: "activityInfo/currentMessageList",
      messageBoardTitle: "activityInfo/messageBoardTitle",
      panelTitleBg: "activityInfo/panelTitleBg"
    }),
    titleIcon() {
      return this.panelTitleBg || TITLE_ICON
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.message-list {
  padding-top: 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 9.01rem;
  overflow: hidden;
  .message-item {
    background: url("../../assets/images/bg_comment_left.png") no-repeat center;
    background-size: 100%;
    margin-bottom: 0.2rem;
    height: 1.14rem;
    width: 100%;
    flex: none;
    overflow: hidden;
    &.bg_gray {
      background: url("../../assets/images/bg_comment_left.png") no-repeat center;
      background-size: 100% 1.14rem;
    }
    &.bg_orange {
      background: url("../../assets/images/bg_comment_right.png") no-repeat center;
      background-size: 100% 1.14rem;
    }
    .message-wrapper {
      height: 0.98rem;
      display: flex;
      align-items: center;
      padding: 0 0.2rem;
      line-height: 0.36rem;
      .message {
        word-break: break-all;
        .name {
          opacity: 0.5;
        }
      }
    }
  }
}
.pc .message-list {
  padding-top: 20px;
  height: 600px;
  .message-item {
    margin-bottom: 10.04px;
    height: 67.6px;
    width: 502px;
    &.bg_orange {
      align-self: flex-end;
      background: url("../../assets/images/bg_comment_right_pc.png") no-repeat center;
      background-size: 100% 67.6px;
    }
    &.bg_gray {
      background: url("../../assets/images/bg_comment_left_pc.png") no-repeat center;
      background-size: 100% 67.6px;
    }
    .message-wrapper {
      height: 56px;
      padding: 0 10px;
      line-height: 28px;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.4s ease;
  transform-origin: 0 50%;
}
.list-enter.message-item {
  opacity: 0;
  transform: translateX(-0.5rem) scaleX(0.7);
  height: 0;
  &.bg_orange {
    transform: translateX(0.5rem) scaleX(1);
  }
}
.pc .list-enter.message-item {
  height: 0;
}
.list-enter-to {
  height: 1.14rem;
  transform: translateX(0);
}
.pc .list-enter-to {
  height: 67.6px;
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-0.2rem);
}
</style>
